import React, { useState } from 'react';
import BarGraph from '../GraphTypes/BarGraph';
import Loader from '../../General/Loader';
import cn from 'classnames';
import { Table } from '../GraphTypes/Table';

import { getBrandReportHeaderLabel } from '../../../helpers/brand_helpers';
import PropTypes from 'prop-types';
import { faDownload } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const BrandOrders = props => {
  const { title, brandOrders: orders, downloading } = props;
  const success = !!orders?.length;

  const [tab, setTab] = useState('table');
  const download_table = async () => await props.download({ rows: make_table_rows(), fileName: 'brand_orders' });
  const download_graph = async () => await props.download({ graph: title });

  const make_table_rows = () => {
    let total_running_total = 0;
    const total_clicks = {
      key: 'orders_total',
      label: 'Total Orders',
      description: '(orders to retail site + DTC site)',
      values: orders.map(order => {
        const { week, month, quarter, total_orders } = order;
        total_running_total += parseInt(total_orders || '0');
        return { label: getBrandReportHeaderLabel({ week, month, quarter }), value: total_orders };
      })
    };
    total_clicks.values.push({ label: 'Total', value: total_running_total });

    let dtc_running_total = 0;
    const dtc_clicks = {
      key: 'orders_dtc',
      label: 'Total Orders DTC',
      description: `(order orders to dtc site)`,
      values: orders.map(click => {
        const { week, month, quarter, total_orders_dtc } = click;
        dtc_running_total += parseInt(total_orders_dtc || '0');
        return { label: getBrandReportHeaderLabel({ week, month, quarter }), value: total_orders_dtc };
      })
    };
    dtc_clicks.values.push({ label: 'Total', value: dtc_running_total });

    let retailer_running_total = 0;
    const retailers_clicks = {
      key: 'orders_retailers_total',
      label: 'Total Orders to Retailers',
      description: `(order orders to retailers of the brand)`,
      values: orders.map(click => {
        const { week, month, quarter, total_orders, total_orders_dtc } = click;
        retailer_running_total += parseInt(total_orders - total_orders_dtc || '0');
        return { label: getBrandReportHeaderLabel({ week, month, quarter }), value: total_orders - total_orders_dtc };
      })
    };
    retailers_clicks.values.push({ label: 'Total', value: retailer_running_total });

    const difference = {
      key: 'orders_diff_total',
      label: 'Share of Orders Going Direct',
      description: '(total orders dtc / total orders overall)',
      values: orders.map(click => {
        const { week, month, quarter, total_orders, total_orders_dtc } = click;
        return {
          label: getBrandReportHeaderLabel({ quarter, week, month }),
          value: (parseInt(total_orders_dtc) / parseInt(total_orders)) * 100,
          isPercent: true
        };
      })
    };
    difference.values.push({ label: 'Total', value: `${((parseInt(dtc_running_total) / parseInt(total_running_total)) * 100).toFixed()}%` });

    let dtc_is_same_as_total = true;
    for (let i = 0; i < total_clicks.values.length; ++i) {
      const total = total_clicks.values[i].value,
        dtc = dtc_clicks.values[i].value;
      dtc_is_same_as_total = dtc_is_same_as_total && total === dtc;
    }

    return dtc_is_same_as_total ? [total_clicks] : [total_clicks, dtc_clicks, retailers_clicks, difference];
  };

  return (
    <div className='brand-card' id={title}>
      <div className='padding'>
        {!orders ? (
          <Loader />
        ) : (
          <>
            {success && (
              <>
                <div className='header'>
                  <div className='description'>
                    <div className='title'>{title}</div>
                    <div className='sub-title'>
                      Orders are defined as the orders for all pins that are DTC or Non DTC to this brand. The orders could contain multiple of the
                      same customer.
                    </div>
                  </div>
                  {!downloading && (
                    <div className='brand-card-controls' id={`${title}-card-controls`}>
                      <div className='radio-btns'>
                        <div className={cn('radio-btn', { active: tab === 'graph' })} onClick={() => setTab('graph')}>
                          Graph
                        </div>
                        <div className={cn('radio-btn', { active: tab === 'table' })} onClick={() => setTab('table')}>
                          Table
                        </div>
                      </div>
                      <div className='rounded-button' onClick={() => (tab === 'table' ? download_table() : download_graph())}>
                        {downloading ? (
                          <Loader />
                        ) : (
                          <>
                            <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                            Download
                          </>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                {tab === 'table' && (
                  <Table
                    title='Brand Orders'
                    data={make_table_rows()}
                    // data={[ { } ]}
                  />
                )}
                {tab === 'graph' && (
                  <BarGraph
                    title='Brand Orders'
                    data={orders.map(click => {
                      const { week, month, quarter, year, total_orders } = click;

                      const data = {
                        key: `${week || month || quarter}${year}orders`,
                        value: total_orders,
                        label: getBrandReportHeaderLabel({ month, quarter })
                      };
                      return data;
                    })}
                  />
                )}
              </>
            )}

            {!success && (
              <>
                <div className='error-centered'>
                  <div className='title'>Error Fetching {title}</div>
                  <div className='sub-title'>Could not fetch results</div>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

BrandOrders.propTypes = {
  title: PropTypes.string.isRequired,
  brandOrders: PropTypes.array,

  download: PropTypes.func.isRequired,
  downloading: PropTypes.bool.isRequired
};

const brandOrderConfig = {
  title: 'Orders'
};

export { BrandOrders, brandOrderConfig };
